
<div class="card">
  <div class="card-body">
    <div>
      <ng-content select="[header]" class="d-flex"></ng-content>
      <div class="row">
        <ng-content select="[button-top]"></ng-content>
        <div *ngIf="showContent" #ref class="col-8 d-flex flex-column justify-content-center">
          <ng-content select="[content]" class="d-flex"></ng-content>
        </div>
        <div class="col label text-center"><h5><strong>{{label}}</strong></h5>
          <div *ngIf="showChartWithMessage" #containerRef id="chart" class="d-flex justify-content-center mt-3">
            <ngx-charts-bar-vertical
              [id]="chartId"
              [view]="view"
              [scheme]="colorScheme"
              [results]="data"
              [gradient]="gradient"
              [xAxis]="showXAxis"
              [yAxis]="showYAxis"
              [animations]="false"
              [legend]="showLegend"
              [showDataLabel]="showDataLabel"
              [showXAxisLabel]="showXAxisLabel"
              [showYAxisLabel]="showYAxisLabel"
              [xAxisLabel]="xAxisLabel"
              [yAxisLabel]="yAxisLabel"
              [legendTitle]="legendTitle"
              [legendPosition]="legendPosition"
              [roundEdges]="false"
              [barPadding]="barPadding"
              [yScaleMin]="yScaleMin"
              [yScaleMax]="yScaleMax"
              [yAxisTicks]="yAxisTicks"
              [trimXAxisTicks]="trimXAxisTicks"
              [dataLabelFormatting]="formatValueFn"
            >
            </ngx-charts-bar-vertical>
          </div>
          <div class="row container-fluid mt-4" style="height: 240px;" *ngIf="!showChartWithMessage">
            <p>
              Não há dados a serem exibidos.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
